import { Link, useLocation } from "react-router-dom";

import { ROUTES } from "../Routes";
import card from '../assets/bestportugalcasino.png'
import { useState } from "react";

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const menuItems = [
    { id: "3253", label: "Início", path: "/" },
    { id: "3256", label: "Sobre Nós", path: ROUTES.ABOUT_US },
    { id: "3255", label: "Jogos", path: ROUTES.GAMES },
    { id: "3254", label: "Contate-nos", path: ROUTES.CONTACT },
  ];

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <>
      

      <div data-elementor-type="header" data-elementor-id="3184" className="elementor elementor-3184 elementor-location-header" data-elementor-post-type="elementor_library">
        <div className="elementor-element elementor-element-eb71684 e-flex e-con-boxed e-con e-parent" data-id="eb71684" data-element_type="container">
          <div className="e-con-inner">

            {/* Barra de Aviso Jogo Responsável */}
            <div className="elementor-element elementor-element-b325106 e-con-full e-flex e-con e-child" data-id="b325106" data-element_type="container" data-settings='{"background_background":"classic"}'>
              <div className="elementor-element elementor-element-469942d elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="469942d" data-element_type="widget" data-widget_type="icon-list.default">
                <div className="elementor-widget-container">
                  <ul className="elementor-icon-list-items">
                    <li className="elementor-icon-list-item">
                      <span className="elementor-icon-list-icon">
                        <svg aria-hidden="true" className="e-font-icon-svg e-fas-exclamation-triangle" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg">
                          <path d="M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"></path>
                        </svg>
                      </span>
                      <span className="elementor-icon-list-text">Este site é apenas para maiores de 18 anos. Jogue com moderação. Se precisa de apoio, visite: jogoresponsavel.pt</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Navegação Principal */}
            <div className="elementor-element elementor-element-4b819c2 e-flex e-con-boxed e-con e-child nav-main-container" data-id="4b819c2" data-element_type="container" data-settings='{"background_background":"classic"}'>
              <div className="e-con-inner nav-inner-container">
                <div className="elementor-element elementor-element-b179a33 e-con-full e-flex e-con e-child nav-logo-container" data-id="b179a33" data-element_type="container">

                  {/* Logo */}
                  <div className="elementor-element elementor-element-5a44b31 elementor-widget__width-initial elementor-widget elementor-widget-theme-site-logo elementor-widget-image nav-logo-wrapper" data-id="5a44b31" data-element_type="widget" data-widget_type="theme-site-logo.default">
                    <div className="elementor-widget-container">
                      <Link to="/">
                        <img
                          src={card}
                          className="attachment-full size-full wp-image-3542"
                          alt="Casinonlineportugal Logo"
                        />
                      </Link>
                    </div>
                  </div>

                  {/* Título do Site */}
                  <div className="elementor-element elementor-element-46a60b5 elementor-widget elementor-widget-theme-site-title elementor-widget-heading nav-title-wrapper" data-id="46a60b5" data-element_type="widget" data-widget_type="theme-site-title.default">
                    <div className="elementor-widget-container">
                      <span className="elementor-heading-title elementor-size-default">
                        <Link to="/">Casinonlineportugal</Link>
                      </span>
                    </div>
                  </div>
                </div>

                {/* Menu de Navegação */}
                <div className="elementor-element elementor-element-9ef339e elementor-nav-menu--dropdown-mobile elementor-nav-menu--stretch elementor-nav-menu__text-align-aside elementor-nav-menu--toggle elementor-nav-menu--burger elementor-widget elementor-widget-nav-menu" data-id="9ef339e">
                  <div className="elementor-widget-container">
                    <nav className="elementor-nav-menu--main elementor-nav-menu__container elementor-nav-menu--layout-horizontal">
                      <ul className="elementor-nav-menu">
                        {menuItems.map((item) => (
                          <li key={item.id} className={`menu-item menu-item-${item.id} ${location.pathname === item.path ? 'current-menu-item' : ''}`}>
                            <Link to={item.path} className={`elementor-item ${location.pathname === item.path ? 'elementor-item-active' : ''}`}>
                              {item.label}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </nav>

                    {/* Toggle Mobile */}
                    <div
                      className={`elementor-menu-toggle ${isMenuOpen ? 'elementor-active' : ''}`}
                      role="button"
                      onClick={toggleMenu}
                      aria-expanded={isMenuOpen}
                    >
                      <svg aria-hidden="true" className="elementor-menu-toggle__icon--open e-font-icon-svg e-eicon-menu-bar" viewBox="0 0 1000 1000"><path d="M104 333H896C929 333 958 304 958 271S929 208 896 208H104C71 208 42 237 42 271S71 333 104 333ZM104 583H896C929 583 958 554 958 521S929 458 896 458H104C71 458 42 487 42 521S71 583 104 583ZM104 833H896C929 833 958 804 958 771S929 708 896 708H104C71 708 42 737 42 771S71 833 104 833Z"></path></svg>
                      <svg aria-hidden="true" className="elementor-menu-toggle__icon--close e-font-icon-svg e-eicon-close" viewBox="0 0 1000 1000"><path d="M742 167L500 408 258 167C246 154 233 150 217 150 196 150 179 158 167 167 154 179 150 196 150 212 150 229 154 242 171 254L408 500 167 742C138 771 138 800 167 829 196 858 225 858 254 829L496 587 738 829C750 842 767 846 783 846 800 846 817 842 829 829 842 817 846 804 846 783 846 767 842 750 829 737L588 500 833 258C863 229 863 200 833 171 804 137 775 137 742 167Z"></path></svg>
                    </div>

                    {/* Dropdown Mobile */}
                    <nav
                      className="elementor-nav-menu--dropdown elementor-nav-menu__container"
                      aria-hidden={!isMenuOpen}
                      style={{
                        display: isMenuOpen ? 'block' : 'none',
                        position: 'absolute',
                        left: 'calc(53px - 100vw)',
                        width: '100vw',
                        top: '33px',
                      }}
                    >
                      <ul className="elementor-nav-menu">
                        {menuItems.map((item) => (
                          <li key={`mob-${item.id}`} className="menu-item" style={{ color: '#f60', }}>
                            <Link
                              to={item.path}
                              className="elementor-item"
                              onClick={() => setIsMenuOpen(false)}
                            >
                              {item.label}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navigation;